// NotificationProvider.js
import { useCallback, useState } from 'react';
import { catchError } from '../services/DaoService';
import NotificationService from '../services/NotificationService';
import PropTypes from 'prop-types';
import { useUserContext } from '../contexts/UserContext';
import NotificationContext from '../contexts/NotificationContext';
import { usePushSubscription } from '../hooks/usePushSubscription';

export const NotificationProvider = ({ children }) => {
    const [unReadNotifications, setUnReadNotifications] = useState([]);
    const [countUnreadNotifications, setCountUnreadNotifications] = useState(0);
    const { currentUser } = useUserContext();
    usePushSubscription(currentUser);

    const loadUnreadNotifications = useCallback(() => {
        if (!currentUser) {
            return;
        }
        NotificationService.getInstance()
            .findUnreadNotifications(currentUser.uid)
            .then(response => {
                setUnReadNotifications(response.data);
            })
            .catch(error => catchError(error));
    }, [currentUser]);

    const loadUnreadNotificationsCount = useCallback(() => {
        if (!currentUser) {
            return;
        }
        NotificationService.getInstance()
            .countUnreadNotifications(currentUser.uid)
            .then(response => {
                setCountUnreadNotifications(response.data);
            })
            .catch(error => catchError(error));
    }, [currentUser]);

    return (
        <NotificationContext.Provider value={{
            unReadNotifications,
            loadUnreadNotifications,
            countUnreadNotifications,
            loadUnreadNotificationsCount
        }}>
            {children}
        </NotificationContext.Provider>
    );
};

NotificationProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
